import { Component, OnInit } from '@angular/core';
import { DirectlySentConsultNotesComponent } from '../../../captures/components/directly-sent-consult-notes/directly-sent-consult-notes.component';

@Component({
    selector: 'app-capture-admin-client-direct-consult-notes',
    templateUrl: './capture-admin-client-direct-consult-notes.component.html',
    styleUrls: ['./capture-admin-client-direct-consult-notes.component.scss'],
    imports: [DirectlySentConsultNotesComponent]
})
export class CaptureAdminClientDirectConsultNotesComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
